import prices from './prices';

const currencyFormatterInstance = new Intl.NumberFormat('nl-NL', {
  style: 'currency',
  currency: 'EUR',
});

const calculateVideoPrice = (words) => {
  const [price] = prices.video.filter((video) => (
    words >= video.min && words <= video.max
  ));

  return (
    price.pricePerWord * (words - price.correction)
  ) + price.fixedFee;
};

const calculateIVRPrice = (words) => {
  if (words > 120) {
    return calculateVideoPrice(words);
  }

  const [price] = prices.ivr.filter((ivr) => (
    words >= ivr.min && words <= ivr.max
  ));

  return price.fee;
};

const calculateCommercialPrice = (
  length = 30,
  medium = 'radio',
  reach = 'national',
) => {
  let fee;
  if (medium === 'online') {
    fee = prices.commercial.buyout.online;
  } else {
    fee = prices.commercial.buyout[medium][reach];
  }

  return {
    buyout: fee,
    fee: prices.commercial.length[length],
  };
};

export default (type, wordsOrLength, medium, reach) => {
  let result;
  let fee;
  switch (type) {
    case 'ivr':
      result = currencyFormatterInstance.format(calculateIVRPrice(wordsOrLength));
      break;
    case 'commercial':
      fee = calculateCommercialPrice(wordsOrLength, medium, reach);
      result = {
        total: currencyFormatterInstance.format(fee.fee + fee.buyout),
        fee: currencyFormatterInstance.format(fee.fee),
        buyout: (fee.buyout === 0 ? 'inclusief' : currencyFormatterInstance.format(fee.buyout)),
      };
      break;
    case 'audiobook':
      result = currencyFormatterInstance.format(prices.audiobook);
      break;
    case 'video':
    default:
      result = currencyFormatterInstance.format(calculateVideoPrice(wordsOrLength));
      break;
  }

  return result;
};
